
export default [
    {
        config: {
            customLanguage: 'en-CT',
            target: null
        },
        operators: {
            'evo-fanduelct0000000': ['fanduelct0000001', 'fanduelctus00002'],
            'evo-draftkingsct0000': ['draftkingsct0001', 'draftkingscthub1']
        }
    },
    {
        config: {
            customLanguage: 'en-ZA',
            target: null
        },
        operators: {
            'evo-10bet00000000000': [],
            'evo-aardvark00000000': [],
            'evo-betcoza000000000': [],
            'evo-betolimpmga00000': [],
            'evo-ragingrivermga00': [],
            'evo-ezugi00000000001': ['101', '102', '103', '104', '105', '106', '107', '108', '109'],
            'evo-gaminghubmga0000': [],
            'evo-intelligent00000': [],
            'evo-interbetmga00000': [],
            'evo-jackpotstar00000': [],
            'evo-lulabets00000000': [],
            'evo-palacebet0000000': [],
            'evo-sunbet0000000000': [],
            'evo-turfsportmga0000': [],
            'evo-worldsports00000': [],
            'evo-yesplay000000000': [],
            'evo-kingmakersmga000': [],
            'evo-spinazonke000000': [],
            'evo-entain0000000000': ['entainza00000001'],
            'evo-betconstruct0000': ['betconstructza01'],
            'evo-compliance000000': ['complsouthafrica'],
        }
    },
];
